/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Action_New_ResumeInputs */

const en_dashboard_action_new_resume = /** @type {(inputs: Dashboard_Action_New_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Resume`)
};

const de_dashboard_action_new_resume = /** @type {(inputs: Dashboard_Action_New_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Lebenslauf`)
};

const fr_dashboard_action_new_resume = /** @type {(inputs: Dashboard_Action_New_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau CV`)
};

const es_dashboard_action_new_resume = /** @type {(inputs: Dashboard_Action_New_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo currículum`)
};

const it_dashboard_action_new_resume = /** @type {(inputs: Dashboard_Action_New_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo Curriculum Vitae`)
};

const nl_dashboard_action_new_resume = /** @type {(inputs: Dashboard_Action_New_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuw CV`)
};

const pl_dashboard_action_new_resume = /** @type {(inputs: Dashboard_Action_New_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowe CV`)
};

const fi_dashboard_action_new_resume = /** @type {(inputs: Dashboard_Action_New_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uusi ansiotodistus`)
};

const da_dashboard_action_new_resume = /** @type {(inputs: Dashboard_Action_New_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyt CV`)
};

const sv_dashboard_action_new_resume = /** @type {(inputs: Dashboard_Action_New_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nytt CV`)
};

/**
* | output |
* | --- |
* | "New Resume" |
*
* @param {Dashboard_Action_New_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_action_new_resume = /** @type {((inputs?: Dashboard_Action_New_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Action_New_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_action_new_resume(inputs)
	if (locale === "fr") return fr_dashboard_action_new_resume(inputs)
	if (locale === "es") return es_dashboard_action_new_resume(inputs)
	if (locale === "it") return it_dashboard_action_new_resume(inputs)
	if (locale === "nl") return nl_dashboard_action_new_resume(inputs)
	if (locale === "pl") return pl_dashboard_action_new_resume(inputs)
	if (locale === "fi") return fi_dashboard_action_new_resume(inputs)
	if (locale === "da") return da_dashboard_action_new_resume(inputs)
	if (locale === "sv") return sv_dashboard_action_new_resume(inputs)
	return en_dashboard_action_new_resume(inputs)
});